import React from 'react'
import PageHeader from '../components/PageHeader'

function Counter() {
  return (
    <div>
      <PageHeader title="Counter" />
    </div>
  )
}

export default Counter
